<template>
  <div>
    <a-menu class='left-menu-inner'
      mode="inline"
      :openKeys="openKeys"
      @openChange="onOpenChange"
      :selectedKeys="selectedKeys"
      :style="{
        height: '100%',
        borderRight: 0,
        'overflow-x': 'hidden',
        'overflow-y': 'auto'
      }"
      @click="handleClick"
    >
      <a-menu-item key="1" @click="gotoAdCenter()">
        <span class='menu-item-title'>
            <img src='https://cmspic-10004025.image.myqcloud.com/00dfd550-2179-11ea-8b50-551bccc0c29f_size_32x32' alt="" width="14" height="14" style="margin-right:8px;"> 
            <span>广告中心</span>
          </span>
        <!-- <span></span> -->
      </a-menu-item>
      <a-sub-menu class='menus level1-meun' v-for="(item) in menus" :key="item.info.key">
        <span class='menu-item-title' slot="title" :title="item.info && item.info.title">
          <img :src="$viewImage(item.info && item.info.icon)" alt="" width="14" height="14">
          <label>{{item.info.title}}</label>
          <div v-if="showReportData" class="node-menu-mask" @click.stop="showTopUser(item.info.key)">
            <div class="click-num">{{clickNum[item.info.key] || 0}}</div>
          </div>
        </span>
        <template v-for="(subItem) in item.children">
          <template v-if="subItem.children && subItem.children.length > 0">
            <a-sub-menu class='menu-item level2-meun' :key="subItem.info.key">
              <span class='menu-item-title' slot="title" :title="subItem.info && subItem.info.title">
                <label>{{subItem.info.title}}</label>
                <div v-if="showReportData" class="node-menu-mask" @click.stop="showTopUser(subItem.info.key)">
                  <div class="click-num">{{clickNum[subItem.info.key] || 0}}</div>
                </div>
              </span>
              <a-menu-item class='sub-menu-item level3-meun' v-for="(subSubItem) in subItem.children" :blankLink="subSubItem.blankLink" :key="subSubItem.info.key" :disabled="showReportData">
                <a :href="subSubItem.info.link" @click="menuSelectHandler(subSubItem, subSubItem.info.key, $event, [item.info.title, subItem.info.title, subSubItem.info.title])" target='iframe-page'>{{subSubItem.info.title}}</a>
                <div v-if="showReportData" class="leaf-menu-mask" @click.stop="showTopUser(subSubItem.info.key)">
                  <div class="click-num">{{clickNum[subSubItem.info.key] || 0}}</div>
                </div>
              </a-menu-item>
            </a-sub-menu>
          </template>
          <template v-else>
            <a-menu-item class='menu-item-leaf level2-meun' :key="subItem.info.key" :blankLink="item.blankLink" :disabled="showReportData">
              <a :href="subItem.info.link" @click="menuSelectHandler(subItem, subItem.info.key, $event, [item.info.title, subItem.info.title])" target='iframe-page'>{{subItem.info.title}}</a>
              <div v-if="showReportData" class="leaf-menu-mask" @click.stop="showTopUser(subItem.info.key)">
                <div class="click-num">{{clickNum[subItem.info.key] || 0}}</div>
              </div>
            </a-menu-item>
          </template>
        </template>
      </a-sub-menu>
    </a-menu>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import {Menu} from 'ant-design-vue'
  import CommonMixin from '@/mixins/global'
  import { tracker } from '@/utils/utils'
  import { mapState, mapActions } from 'vuex'
  const {SubMenu, Item} = Menu
  export default {
    name: "left-menu",
    components: {
      [Menu.name]: Menu,
      [SubMenu.name]: SubMenu,
      [Item.name]: Item
    },
    mixins: [ CommonMixin ],
    data () {
      return {
        openKeys: [],
        selectedKeys: [],
        defaultSelectKeyStr: ''
      }
    },
    computed: {
      ...mapState('heatmap', ['showReportData', 'clickNum'])
    },
    watch: {
      menus() {
        const link = this.$route.query.link || ''
        if (link) {
          this.getSelectMenuKey(this.menus, link)
          if (this.defaultSelectKeyStr) {
            const arr = this.defaultSelectKeyStr.split('/')
            // this.defaultSelectedKeys = [this.defaultSelectKeyStr]
            this.selectedKeys = [this.defaultSelectKeyStr]
            const set = new Set()
            for(let i = arr.length -1; i--; i>=0) {
              arr.pop()
              set.add(arr.join('/'))
            }
            // this.defaultOpenKeys = [...set]
            this.openKeys = [...set]
          }
        }
      },
      showReportData() {
        setTimeout(() => {
          if (this.showReportData) {
            document.querySelectorAll('.level1-meun > .ant-menu-submenu-title').forEach(item => item.classList.add('level1-bg'))
            document.querySelectorAll('.level2-meun > .ant-menu-submenu-title').forEach(item => item.classList.add('level2-bg'))
            document.querySelectorAll('.menu-item-leaf.level2-meun').forEach(item => item.classList.add('level2-bg'))
            document.querySelectorAll('.level3-meun').forEach(item => item.classList.add('level3-bg'))
          } else {
            document.querySelectorAll('.level1-meun > .ant-menu-submenu-title').forEach(item => item.classList.remove('level1-bg'))
            document.querySelectorAll('.level2-meun > .ant-menu-submenu-title').forEach(item => item.classList.remove('level2-bg'))
            document.querySelectorAll('.menu-item-leaf.level2-meun').forEach(item => item.classList.remove('level2-bg'))
            document.querySelectorAll('.level3-meun').forEach(item => item.classList.remove('level3-bg'))
          }
        }, 0)
      }
    },
    methods: {
      ...mapActions('heatmap', ['e', 'getTopUser', 'getPositionCount']),
      handleClick({ key }) {
        this.selectedKeys = [key]
      },
      getSelectMenuKey(menus, link) {
        for(const menu of menus) {
          if (menu.children && menu.children.length > 0) {
            this.getSelectMenuKey(menu.children, link)
          } else {
            if (menu.info.link === link) {
              this.defaultSelectKeyStr = menu.info.key
              break
            }
          }
        }
        if (this.defaultSelectKeyStr) {
          return this.defaultSelectKeyStr
        }
      },
      menuSelectHandler (item, key, e, menuPath) {
        this.setCurrentMenuPath(menuPath)
        const { buzzType } = this.userInfo
        // 热力图统计埋点数据上报
        if (buzzType === 1 || buzzType === 2) {
          // pop
          tracker(116, 121013119, 20000, 200001, {path: key})
        } else if (buzzType === 3) {
          // 品牌商
          tracker(116, 121013121, 20000, 200001, {path: key})
        } else if (buzzType === 4) {
          // 供应商
          tracker(116, 121013122, 20000, 200001, {path: key})
        }
        const { openKeys } = this
        this.$emit('change', {...item, openKeys, selectedKeys: [key]})
        e.preventDefault()
        return false
      },
      async onOpenChange(openKeys) {
        
        if (openKeys.length === 0) {
          this.openKeys = []
          this.handleMenuOpenChange('')
        } else if (openKeys.length === 1) {
          this.openKeys = openKeys
          this.handleMenuOpenChange(openKeys[0])
          if (this.showReportData) {
            await this.getPositionCount()
          }
        } else {
          let index = openKeys.length - 1
          let currentOpenKey = openKeys[index]
          if (!currentOpenKey.includes('/')) {
            // 一级菜单
            this.openKeys = [currentOpenKey]
          } else {
            // 二级菜单
            this.openKeys = [openKeys[0], currentOpenKey]
          }
          this.handleMenuOpenChange(currentOpenKey)
          if (this.showReportData) {
            await this.getPositionCount()
          }
        }
        if (this.showReportData) {
          setTimeout(() => {
            document.querySelectorAll('.level2-meun > .ant-menu-submenu-title').forEach(item => item.classList.add('level2-bg'))
            document.querySelectorAll('.menu-item-leaf.level2-meun').forEach(item => item.classList.add('level2-bg'))
            document.querySelectorAll('.level3-meun').forEach(item => item.classList.add('level3-bg'))
          }, 0)
        }
      },
      selectHandler({ item, selectedKeys }) {
        const { $attrs } = item
        // 外链选中状态不触发
        if (!$attrs.blankLink) {
          this.selectedKeys = selectedKeys
        }
      },
      showTopUser(menuKey) {
        this.getTopUser({menuKey})
      },
      gotoAdCenter(){
        const PROTOCOL = process.env.VUE_APP_SEVERENV === 'BETA' ? 'http' : 'https'
        window.location.href = `${PROTOCOL}://open.haiziwang.com/platform/ad`
        // this.$router.push({path: '/ad'})
      },
     
    }
  }
</script>

<style lang="scss">
.left-menu-inner{
  &::-webkit-scrollbar {
    display: none;
  }
}
.ant-menu-item{
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 16px !important;
    border-right: 0;
  }
  .ant-menu-item-selected {
    &::after{
      left:0;
      right: unset;
      // border-left: 3px solid $primary-main;
      border-right: 0 !important;
    }
  }
.menus{
  > .ant-menu-submenu-title{
    padding-left: 16px !important;
  }
  .menu-item{
    .ant-menu-submenu-title{
      padding-left: 30px !important;
    }
  }
 
  .sub-menu-item{
    padding-left: 50px !important;
  }
  .menu-item-leaf{
    padding-left: 38px !important;
  }
  &.ant-menu-submenu-selected{
    .menu-item-title{
      color: $title-color-333;
    }
  }
  .ant-menu-submenu-arrow{
    &::before{
      background-image: linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)) !important;
    }
    &::after{
      background-image: linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)) !important;
    }
  }
  .menu-item-title{
    display: flex;
    align-items: center;

    label{
      padding-left: 8px;
    }
  }
  .ant-menu-item-selected{
    &::after{
      left:0;
      right: unset;
      border-left: 3px solid $primary-main;
      border-right: 0;
    }
  }
  .ant-menu-item-disabled > a, .ant-menu-submenu-disabled > a {
    color: rgba(0, 0, 0, 0.65) !important;
  }
  .click-num {
    border-radius: 4px;
    color: #f7f7f7;
    font-weight: 500;
    height: 20px;
    line-height: 20px;
    position: relative;
    top: -10px;
    padding: 0 12px;
    display: inline-block;
  }
  .level1-bg {
    background: rgba(255,117,116,0.3) !important;
    color: #976D6D !important;
    .ant-menu-submenu-arrow::before, .ant-menu-submenu-arrow::after {
      background: #333 !important;
    }
    .click-num {
      background: #ff2d2d;
    }
  }
  .level2-bg {
    background: rgba(0,113,255,0.13) !important;
    color: #647486 !important;
    .ant-menu-submenu-arrow::before, .ant-menu-submenu-arrow::after {
      background: #333 !important;
    }
    .click-num {
      background: #0071ff;
    }
  }
  .level3-bg {
    background: rgba(10,255,176,0.13) !important;
    color: #719288 !important;
    .click-num {
      background: #20da9e;
    }
  }
  .leaf-menu-mask {
    width: 186px;
    height: 40px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    cursor: pointer;
  }
  .node-menu-mask {
    width: 152px;
    height: 40px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    cursor: pointer;
  }
}
</style>
